import React, { useCallback, useEffect } from 'react';
import { formatNewsTime } from 'utils';

export const Title = ({
  title,
  companyName,
  reporterName,
  createTime,
  updateTime,
  fontSize,
  setFontSize,
}: {
  title: string;
  companyName: string;
  reporterName: string;
  createTime: string;
  updateTime: string;
  fontSize: number;
  setFontSize: Function;
}) => {
  useEffect(() => {
    document.title = title;
  }, [title]);

  const handleFontDown = useCallback(
    (e) => {
      e.preventDefault();
      if (fontSize > 1) {
        setFontSize(fontSize - 1);
      }
    },
    [fontSize, setFontSize],
  );

  const handleFontUp = useCallback(
    (e) => {
      e.preventDefault();
      if (fontSize < 5) {
        setFontSize(fontSize + 1);
      }
    },
    [fontSize, setFontSize],
  );
  return (
    <div className="newsTit">
      <em>
        <a href="#">{companyName}</a>
      </em>
      <h5>{title}</h5>
      <div className="" style={{ overflow: 'hidden', marginTop: 13 }}>
        <div className="info">
          <span>입력: {formatNewsTime(createTime)}</span>
          <span>수정: {formatNewsTime(updateTime)}</span>
        </div>
        <div className="fontSize">
          <a href="#" className={`sizeDown ${fontSize === 1 ? 'off' : ''}`} title="글짜 작게" onClick={handleFontDown}>
            가
          </a>
          <a href="#" className={`sizeUp ${fontSize === 5 ? 'off' : ''}`} title="글짜 크게" onClick={handleFontUp}>
            가
          </a>
        </div>
      </div>
    </div>
  );
};
